import colors from "./colors";
import textStyles from "./textStyle";
import borderRadius from "./radius";

export default {
  colors,
  textStyles,
  borderRadius,
};
